import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Helmet } from 'react-helmet-async';

let externalUrlToVisit = '';

const pdfFiles = [
    { title: 'Consent to Treatment (Guardian)', url: '/pdfs/ConsenttoTreatGuardian.pdf' },
    { title: 'Consent to Treatment (Patient)', url: '/pdfs/ConsenttoTreatPatient.pdf' },
    { title: 'Notice of Court/Legal Services Policy', url: '/pdfs/CourtLegalPolicy.pdf' },
    { title: 'Legal Consent for Child & Adolescent Clients', url: '/pdfs/LegalConsentforChild-AdolescentClients.pdf' },
    { title: 'Medication Adherence Agreement', url: '/pdfs/MedicationAdherenceAgreement.pdf' },
    { title: 'Notice of Privacy Practices', url: '/pdfs/NoticeofPrivacyPractices.pdf' },
    { title: 'Notice of Privacy Practices with Acknowledgement', url: '/pdfs/NoticeofPrivacyPracticeswithAcknowledgement.pdf' },
    { title: 'Private Pay Agreement', url: '/pdfs/PrivatePayAgreement.pdf' },
    { title: 'Release of Information', url: '/pdfs/ReleaseofInformation.pdf' },
];



const Resources = () => {
    const [selectedPdf, setSelectedPdf] = useState(null);


    useEffect(() => {
        const confirmBtn = document.getElementById('confirmExternalLink');
        if (confirmBtn) {
            const handleClick = () => {
                window.location.href = externalUrlToVisit;
            };

            confirmBtn.addEventListener('click', handleClick);

            return () => {
                confirmBtn.removeEventListener('click', handleClick);
            };
        }
    }, []);

    return (
        <>
            <Helmet>
                <title>Resources & Learning | Redemption Psychiatry</title>
            </Helmet>
            <div className="wrap">
                <Header />
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <div id="content" role="main" className="home">

                        {/* Interior Header */}
                        <div id="interior-header-container" className="container-fluid">
                            <div className="container">
                                <h1>Resources and Learning</h1>
                            </div>
                        </div>

                        {/* Intro Section */}
                        <div className="container py-5">
                            <div className="row align-items-center mb-5">
                                <div className="col-md-6">
                                    <h2>Knowledge is Power. Support is Essential.</h2>
                                    <p>
                                        At Redemption Psychiatry, we believe that education and access to resources play a crucial role in healing and long-term mental wellness.
                                        Whether you're looking for practical patient guides, forms, and FAQs or want to dive deeper into the latest research, articles, and podcasts,
                                        you'll find it all here.
                                    </p>
                                </div>
                                <div className="col-md-6">
                                    <LazyLoadImage
                                        src="/img/resources-and-learning.jpg"
                                        alt="Resources Support"
                                        effect="blur"
                                        className="img-fluid rounded"
                                    />
                                </div>
                            </div>

                            {/* Decorative Divider */}
                            <div
                                style={{
                                    width: '100%',
                                    height: '5px',
                                    backgroundColor: '#2D4F91',
                                    margin: '40px 0'
                                }}
                            ></div>


                            {/* Resource Cards */}
                            {/* Cards Header */}
                            <div id="services-cards-container" className="container">
                                <p className="large">
                                    Explore evidence-based information and tools that support your mental health journey.
                                </p>
                                {/* Services Cards */}
                                <p className="large">
                                    We combine the latest scientific breakthroughs with a deep commitment to patient care—because you deserve treatment that truly works for you.
                                </p>
                                <div>
                                    <div>
                                        <div>
                                            <h3>Make a Payment Online</h3>
                                            <p>Fast and secure way to make a payment, click the link and fill out the following form.</p>
                                            <a href="https://www.patientnotebook.com/redemption/Enhanced/SendMoney/MakePayment" className="button blue" target="_blank" rel="noopener noreferrer">Make a Payment</a>
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <h3>Medication Refills</h3>
                                            <p>Request a medication refill using this form.</p>
                                            <a href="/medication-refill" className="button blue">Request Refill</a>

                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <h3>Patient Forms</h3>
                                            <p>View/Download/Print our patient forms as needed.</p>
                                            <button
                                                className="button blue"
                                                onClick={() => {
                                                    const modal = new window.bootstrap.Modal(document.getElementById('pdfModal'));
                                                    modal.show();
                                                }}
                                            >
                                                View Forms
                                            </button>
                                        </div>
                                    </div>

                                    <div>
                                        <div>
                                            <h3>Pamphlets</h3>
                                            <p>See what we do at a glance!</p>
                                            <a href="/pamphlets" className="button blue">Learn More</a>
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <h3>TMS</h3>
                                            <p>Learn more about how TMS works, the research behind it, and why doctors trust it.</p>
                                            <a
                                                href="https://revolutiontreatments.com/tms"
                                                className="button blue"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    externalUrlToVisit = "https://revolutiontreatments.com/tms";
                                                    const modal = new window.bootstrap.Modal(document.getElementById('externalLinkModal'));
                                                    modal.show();
                                                }}
                                            >
                                                Learn More at Revolution Treatments
                                            </a>
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <h3>Ketamine</h3>
                                            <p>Understand where Ketamine comes from, why it's used for mental health, and what different options are beneficial.</p>
                                            <a
                                                href="https://revolutiontreatments.com/ketamine"
                                                className="button blue"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    externalUrlToVisit = "https://revolutiontreatments.com/ketamine";
                                                    const modal = new window.bootstrap.Modal(document.getElementById('externalLinkModal'));
                                                    modal.show();
                                                }}
                                            >
                                                Learn More at Revolution Treatments
                                            </a>
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <h3>Deep Brain Stimulation</h3>
                                            <p>Learn about DBS, a revolutionary treatment for OCD.</p>
                                            <a
                                                href="https://revolutiontreatments.com/dbs"
                                                className="button blue"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    externalUrlToVisit = "https://revolutiontreatments.com/dbs";
                                                    const modal = new window.bootstrap.Modal(document.getElementById('externalLinkModal'));
                                                    modal.show();
                                                }}
                                            >
                                                Learn More at Revolution Treatments
                                            </a>

                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <h3>Media</h3>
                                            <p>Check out our podcasts, videos, and other educational content.</p>
                                            <a href="/media" className="button blue">Explore Media</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* CTA */}
                            <div className="text-center py-4">
                                <h3>Looking for Something Else?</h3>
                                <p>Call or fax our office and we'll be happy to assist.</p>
                                <p>Phone: <a href="tel:+14804718560">(480) 471-8560</a> Fax: (888) 979-8197</p>
                            </div>
                        </div>
                    </div>
                    <div className="push"></div>
                </motion.div>
                <Footer />
                <div
                    className="modal fade"
                    id="externalLinkModal"
                    tabIndex="-1"
                    aria-labelledby="externalLinkModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="externalLinkModalLabel">Leaving rpsych.com</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                You are about to leave rpsych.com and visit our sister site at revolutiontreatments.com. Would you like to continue?
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                                <button type="button" className="btn btn-primary" id="confirmExternalLink">Continue</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* PDF Modal */}
                <div className="modal fade" id="pdfModal" tabIndex="-1" aria-labelledby="pdfModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl modal-dialog-centered modal-fullscreen-md-down">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title w-100 text-center" id="pdfModalLabel">Patient Forms</h3>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>

                            <div className="modal-body row" style={{ margin: '0' }}>
                                <div className="col-md-4 border-end p-0" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                    {pdfFiles.map((file, idx) => (
                                        <div key={idx} className="mb-1">
                                            <motion.button
                                                className={`pdf-link-button ${selectedPdf === file.url ? 'active' : ''}`}
                                                onClick={() => setSelectedPdf(file.url)}
                                                initial={false}
                                                animate={{ scale: selectedPdf === file.url ? 1 : 0.9 }}
                                                transition={{ type: 'spring', stiffness: 300, damping: 20 }}
                                                style={{ fontSize: '18px' }}
                                            >
                                                {file.title}
                                                {selectedPdf === file.url && (
                                                    <motion.div
                                                        layoutId="pdf-underline"
                                                        className="pdf-link-underline"
                                                        transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                                                    />
                                                )}
                                            </motion.button>
                                        </div>
                                    ))}

                                </div>
                                {/* PDF Viewer */}
                                <div className="col-md-8 p-0 d-flex flex-column align-items-center">
                                    {selectedPdf ? (
                                        <>
                                            <iframe
                                                src={selectedPdf}
                                                title="PDF Viewer"
                                                width="100%"
                                                height="500px"
                                                style={{ border: 'none', display: 'block' }}
                                            />
                                            <div className="mt-2">
                                                <a href={selectedPdf} download className="btn btn-sm btn-success me-2">Download</a>
                                                <button onClick={() => window.print()} className="btn btn-sm btn-secondary">Print</button>
                                            </div>
                                        </>
                                    ) : (
                                        <p>Select a file to view it.</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Resources;
